import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guarantee } from '../data/content';
export function Guarantee() {
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="guarantee-title" data-id="element-91" data-mp="1o33u6h0ytshr">
      <div className="mx-auto max-w-[880px] px-5 text-center sm:px-8" data-id="element-92" data-mp="222d797tvk6hi">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-sage-deep text-paper" data-id="element-93" data-mp="1x3to1f6o18su">
          <ShieldCheckIcon className="h-8 w-8" strokeWidth={1.6} aria-hidden="true" data-id="element-94" data-mp="19dz8gpuyp64w" />
        </span>
        <p className="mt-6 text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-95" data-mp="14gforafhw15k">Garantía de {guarantee.days} días</p>
        <h2 id="guarantee-title" className="mt-3 font-display text-4xl text-petrol sm:text-5xl" data-id="element-96" data-mp="1j6501yhaxljk">
          Probalo con <em className="text-sage-deep" data-id="element-97" data-mp="1ecizv5sbra4n">tranquilidad</em>
        </h2>
        <div className="mt-8 rounded-2xl bg-paper p-7 shadow-soft ring-1 ring-cream-line sm:p-10" data-id="element-98" data-mp="qn7vzffogzma">
          <p className="text-lg leading-relaxed text-ink-soft" data-id="element-99" data-mp="lo4wsbmdpnm8">{guarantee.text}</p>
        </div>
      </div>
    </section>;
}